import axiosInstance from "./axiosInstance";

const crearUsuario = async (adminId, data) => {
  return await axiosInstance.post(`${process.env.REACT_APP_BASE_URL}/crearUsuario`, {
    adminId,
    ...data,
  });
};

export default crearUsuario;
